export default "__VITE_ASSET__j4xEYmh7__"